import { render, staticRenderFns } from "./thirdStep - 副本.vue?vue&type=template&id=08069a45&scoped=true&"
import script from "./thirdStep - 副本.vue?vue&type=script&lang=js&"
export * from "./thirdStep - 副本.vue?vue&type=script&lang=js&"
import style0 from "./thirdStep - 副本.vue?vue&type=style&index=0&id=08069a45&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08069a45",
  null
  
)

export default component.exports